export const profileMenuItems = [
  { id: 'bookings', label: 'الحجوزات' },
  { id: 'favorites', label: 'المفضلة' },
  { id: 'payments', label: 'سجل المدفوعات' },
  { id: 'settings', label: 'الإعدادات' },
];

export const bookingFilters = [
  { id: 'all', label: 'الجميع' },
  { id: 'active', label: 'جاري' },
  { id: 'completed', label: 'مكتمل' },
  { id: 'cancelled', label: 'ملغي' },
];

export const profileBookings = [
  {
    id: 'BK-1024',
    image: '/image/1.jpg',
    furnishing: 'مفروش بالكامل',
    availability: 'متاحة الآن',
    category: 'شقة فندقية',
    period: 'يومي',
    title: 'فيلا الياسمين',
    location: 'دبي - برج العرب',
    bookingStatus: 'جاري',
    bookingNumber: '1024#',
    bookingDate: '2025 مايو 10',
    total: '798.09',
  },
  {
    id: 'BK-1026',
    image: '/image/2.jpg',
    furnishing: 'مفروش بالكامل',
    availability: 'متاحة الآن',
    category: 'شقة فندقية',
    period: 'شهري',
    title: 'شقة بالكندية',
    location: 'دبي - برج العرب',
    bookingStatus: 'مكتمل',
    bookingNumber: '1026#',
    bookingDate: '2025 يونيو 18',
    total: '1620.00',
  },
  {
    id: 'BK-1031',
    image: '/image/3.jpg',
    furnishing: 'مفروش بالكامل',
    availability: 'متاحة الآن',
    category: 'شاليه',
    period: 'سنوي',
    title: 'شاليه كابيتال ستار',
    location: 'دبي - برج العرب',
    bookingStatus: 'ملغي',
    bookingNumber: '1031#',
    bookingDate: '2025 يوليو 03',
    total: '798.09',
  },
];

export const favoriteProperties = [
  {
    id: 401,
    image: '/image/1.jpg',
    type: 'مفروش بالكامل',
    status: 'متاح الآن',
    title: 'فيلا الريم',
    subtitle: 'وحدة سكنية',
    location: 'القصيم السعودية - أبها الشام',
    rating: '5.0',
    stars: 5,
    price: '22,000',
    period: 'يوميًا',
    bedrooms: '4',
    bathrooms: '2',
    area: '92.86',
  },
  {
    id: 402,
    image: '/image/2.jpg',
    type: 'مفروش بالكامل',
    status: 'متاح الآن',
    title: 'شقة سكنية',
    subtitle: 'وحدة سكنية',
    location: 'القصيم السعودية - أبها الشام',
    rating: '5.0',
    stars: 5,
    price: '22,000',
    period: 'يوميًا',
    bedrooms: '4',
    bathrooms: '2',
    area: '92.86',
  },
  {
    id: 403,
    image: '/image/3.jpg',
    type: 'مفروش بالكامل',
    status: 'متاح الآن',
    title: 'شاليه كابيتال ستار',
    subtitle: 'وحدة سكنية',
    location: 'القصيم السعودية - أبها الشام',
    rating: '5.0',
    stars: 5,
    price: '22,000',
    period: 'يوميًا',
    bedrooms: '4',
    bathrooms: '2',
    area: '92.86',
  },
  {
    id: 404,
    image: '/image/3.jpg',
    type: 'مفروش بالكامل',
    status: 'متاح الآن',
    title: 'شاليه كابيتال ستار',
    subtitle: 'وحدة سكنية',
    location: 'القصيم السعودية - أبها الشام',
    rating: '5.0',
    stars: 5,
    price: '22,000',
    period: 'يوميًا',
    bedrooms: '4',
    bathrooms: '2',
    area: '92.86',
  },
];

export const paymentRecords = [
  {
    id: '#1205',
    title: 'شقة سكنية - مدينة نصر',
    date: '31 أكتوبر 2025',
    methodImage: '/image/28.png',
    methodAlt: 'Visa',
    amount: '798.09',
    status: 'ناجحة',
    invoiceLabel: 'عرض الإيصال',
  },
  {
    id: '#1189',
    title: 'فيلا الريم - حي الياسمين',
    date: '31 أكتوبر 2025',
    methodImage: '/image/29.png',
    methodAlt: 'mada',
    amount: '798.09',
    status: 'ناجحة',
    invoiceLabel: 'عرض الإيصال',
  },
  {
    id: '#1205',
    title: 'شقة سكنية - الرياض',
    date: '31 أكتوبر 2025',
    methodImage: '/image/28.png',
    methodAlt: 'Visa',
    amount: '798.09',
    status: 'فشلت',
    invoiceLabel: 'عرض الإيصال',
  },
  {
    id: '#1175',
    title: 'مكتب تجاري',
    date: '31 أكتوبر 2025',
    methodImage: '/image/30.png',
    methodAlt: 'Mastercard',
    amount: '798.09',
    status: 'ناجحة',
    invoiceLabel: 'عرض الإيصال',
  },
];

export const settingsRows = [
  {
    id: 'password',
    label: 'تغير كلمة المرور',
    type: 'action',
  },
  {
    id: 'notifications',
    label: 'تفعيل الإشعارات',
    type: 'toggle',
    enabled: false,
  },
  {
    id: 'dark_mode',
    label: 'تفعيل الوضع الليلي',
    type: 'toggle',
    enabled: false,
  },
];
